export default "__VITE_ASSET__2ZK5DJkg__"